import {AuthorityType, ContentType, CountryCode, OrganisationCode} from "~/app/components/document/document.model";
import {Document} from "./document.model";
import {OriginCode} from "~/app/components/document/document.filters";

export const COUNTRY_LABELS: Record<CountryCode, string> = {
  DE: "Deutschland",
  ES: "Spanien",
  AL: "Albanien",
  CO: "Kolumbien",
  SI: "Slowenien",
  AT: "Österreich",
  RO: "Rumänien",
  LT: "Litauen",
  PE: "Peru",
  CY: "Zypern",
  CH: "Schweiz",
  BE: "Belgien",
  FR: "Frankreich",
  CR: "Costa Rica",
  NO: "Norwegen",
  UA: "Ukraine"
};

export const ORGANISATION_LABELS: Record<OrganisationCode, string> = {
  UN: "Vereinte Nationen",
  EU: "Europäische Union"
};

export const AUTHORITY_LABELS: Record<AuthorityType, string> = {
  ministry: "Ministerium",
  foreign_ministry: "Außenministerium",
  court: "Gericht",
  parliament: "Parlament",
  law_enforcement: "Strafverfolgungsbehörde",
  municipal_authority: "Kommunale Behörde",
  federal_authority: "Bundesbehörde",
  data_protection_authority: "Datenschutzbehörde",
  ombudsman: "Ombudsstelle",
  international_body: "Internationale Organisation",
  embassy: "Botschaft",
  other: "Sonstige staatliche Stelle"
};

export const CONTENT_LABELS: Record<ContentType, string> = {
  CITIZENSHIP: "Staatsangehörigkeit",
  GENERAL: "Allgemein"
};

export function countryLabel(code: CountryCode): string {
  return COUNTRY_LABELS[code];
}

export function organisationLabel(code: OrganisationCode): string {
  return ORGANISATION_LABELS[code];
}

export function authorityLabel(type: AuthorityType): string {
  return AUTHORITY_LABELS[type];
}

export function contentLabel(type: ContentType): string {
  return CONTENT_LABELS[type];
}

export function originCodeLabel(code: OriginCode): string {
  if ((code as OrganisationCode) in ORGANISATION_LABELS) {
    return organisationLabel(code as OrganisationCode);
  }

  return countryLabel(code as CountryCode);
}

export function buildDocumentTitle(document: Document): string {
  const { origin, authorityType } = document;

  let originLabel: string;

  if (origin.kind === "state") {
    originLabel = countryLabel(origin.code);
  } else if (origin.kind === "international_organisation") {
    originLabel = organisationLabel(origin.code);
  } else {
    originLabel = origin.code;
  }

  const authority = AUTHORITY_LABELS[authorityType];

  return `${originLabel} – ${authority}`;
}
